import Vue from "vue";

export const NoteAttachmentEventBus = new Vue();
